import { type Context, createContext } from "react"
import type { EventNode, TypedEvent } from "#js/util/component-hierarchy"

export const ComponentHierarchyContext: Context<EventNode<TypedEvent> | null> =
  createContext<EventNode<TypedEvent> | null>(null)
